<template>
  <div class="h5-partner">
    <div class="h5-partner-container">
      <img
        class="split-line"
        src="@/assets/H5/home/h5-split-line.svg"
        alt=""
      >
      <div class="h5-partner-container-left">
        <div class="left-line1">
          <img
            src="@/assets/header/trusted-choice.svg"
            alt=""
          >
          <div class="left-line1-text">
            Trusted Choice
          </div>
        </div>
        <div class="left-line2">
          100% safety guarantee for you
        </div>
      </div>
      <div class="h5-partner-container-right">
        <div
          class="scroll-container"
          ref="scrollContainer"
        >
          <div
            class="scroll-content"
            ref="scrollContent"
          >
            <div
              class="content"
              v-for="(item, i) in scrollItems"
              :key="i"
            >
              <div class="left-line1">
                <div v-html="item.line1" />
              </div>
              <div class="left-line2">
                {{ item.line2 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const scrollContainer = ref(null)
const scrollContent = ref(null)

const is1688 = location.hostname.includes('1688')

const scrollItems = ref([
  {
    line1: `<span style="color: #F5804E;">${is1688 ? '1688' : 'Factory'}</span> ${is1688 ? 'Official Partner' : 'Direct Sales'}`,
    line2: 'Origin Supply, Honest Pricing'
  },
  {
    line1: '<span style="color: #F5804E;">Secure</span> Payment',
    line2: 'Worry-Free Transactions'
  },
  {
    line1: 'Global <span style="color: #F5804E;">Delivery</span>',
    line2: 'Global Warehouse'
  }
])

const contentHeight = 58
let scrollIndex = 0

onMounted(() => {
  startAutoScroll()
})

const startAutoScroll = () => {
  const content = scrollContent.value
  // 克隆一份内容追加在后面，实现无缝滚动
  const clone = content.cloneNode(true)
  content.parentElement.appendChild(clone)

  setInterval(() => {
    scrollIndex++
    content.parentElement.style.transition = 'transform 1s ease-in-out'
    content.parentElement.style.transform = `translateY(-${scrollIndex * contentHeight}px)`

    // 重置位置（无动画）
    if (scrollIndex >= scrollItems.value.length) {
      setTimeout(() => {
        content.parentElement.style.transition = 'none'
        content.parentElement.style.transform = 'translateY(0)'
        scrollIndex = 0
      }, 1000)
    }
  }, 5000)
}
</script>
<style lang="less" scoped>
  .h5-partner {
    height: 56px;
    background-color: #052784;
    padding: 0 12px;

    .h5-partner-container {
      position: relative;
      height: 100%;
      display: flex;
      background: linear-gradient(
        to right,
        #0DA3A3,
        #295FCC,
        #5252E5,
        #295FCC,
        #0DA3A3
      );
      border-radius: 8px;

      .split-line {
        position: absolute;
        left: 50%;
        top: 11px;
        transform: translateX(-50%);
      }

      .h5-partner-container-left, .h5-partner-container-right {
        width: 50%;
        height: 100%;

        .left-line1 {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          font-family: mon-700;
          color: white;
          line-height: 16px;
          img {
            margin-right: 2px;
          }
        }
        .left-line2 {
          margin-top: 2px;
          font-family: mon-500;
          font-size: 11px;
          color: #EBF5FF;
          line-height: 16px;
          white-space: nowrap;
        }
      }
      .h5-partner-container-left {
        box-sizing: border-box;
        padding-top: 10px;
        padding-left: 12px;
      }
      .h5-partner-container-right {
        overflow: hidden;

        .content-wrapper {
          transition: all 1s;
        }
        .content {
          height: 58px;
          padding-top: 12px;
          padding-left: 12px;
          box-sizing: border-box;
        }
      }
    }
  }
</style>
